<template>
    <div class="container-card">
        <div class="card rounded-top rounded-0">
            <h6 class="container-card-title"
                @dblclick="fixed !== true ? showFilters = !showFilters : false">
                <span>
                    <i class="container-card-icon fas float-left" :class="icon"></i>
                    <Breadcumbs class="d-inline-block" style="position: absolute" v-if="componentPath != undefined"
                        :paths="componentPath"
                    />
                    <span v-if="title" class="d-inline-block" style="width:auto;">{{ title }}</span>
                </span>
                
                <i v-if="fixed !== true" v-b-toggle="'collapse-'+id" class="fas fa-minus float-right container-card-toggle" :class="showFilters ? 'fa-minus' : 'fa-plus'" style="cursor: pointer;"></i>
            </h6>
        </div>
        <b-collapse :id="'collapse-'+id" visible class="mt-0" v-model="showFilters">
            <slot></slot>
        </b-collapse>
    </div>
</template>
<script>
import Breadcumbs from '@/components/BreadCumb'

export default {
    name: 'container-card',
    components:{
        Breadcumbs
    },
    props: {
        id: String,
        icon: String,
        title: String,
        fixed: {
            type: Boolean,
            required: false
        },
        componentPath: Array
    },
    data(){
        return {
            showFilters: true
        }
    }
}
</script>
<style lang="scss" scoped>
    .container-card{
        border-top: 2px solid #769ec3;
        padding: 0;
        border-radius: 4px;
        box-shadow: 0px 1px 0px 0px #afafaf;
        font-weight: 600;
        color: #505458;
        margin-bottom: 20px;
        .container-card-title{
            margin: 7px 10px  9px;
            span {
              width: 93%;
              display: inline-block;
            }
            .container-card-icon {
              margin-right: 4px;
              color: #769ec3;
            }
        }
        .container-card-toggle {
            padding: 3px 5px;
            margin: 0 -4px;
            font-size: 13px;
            border-radius: 3px;
            box-shadow: 0px 0px 1px 1px #bdbdbd;
            transition: 0.2s;
            &:hover {
                background: #f3f3f3;
            }
        }
        
        @media only screen and (max-width: 767px){
            .card{
                min-height: 80px !important;
            }
        }
    }
</style>
